import { render, staticRenderFns } from "./BuscaClientes.vue?vue&type=template&id=6320ccc2&scoped=true&"
import script from "./BuscaClientes.vue?vue&type=script&lang=js&"
export * from "./BuscaClientes.vue?vue&type=script&lang=js&"
import style0 from "./BuscaClientes.vue?vue&type=style&index=0&id=6320ccc2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6320ccc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDataTable,VLayout,VProgressCircular,VRow,VTextField})
